export default {"src":"/_next/static/media/happy-face-icon.c7864d23.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};